


import VueHtml2pdf from 'vue-html2pdf'
import AtomButton from "../atoms/AtomButton.vue";
import AtomImage from "../atoms/AtomImage.vue";
import AtomLogo from "../atoms/AtomLogo.vue";
import MoleculeContentBlock from "../molecules/MoleculeContentBlock.vue";
import {computed, defineComponent, ref} from "@vue/composition-api";
import {useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: "PdfComponent",
  components: {
    AtomButton,
    AtomImage,
    AtomLogo,
    MoleculeContentBlock,
    VueHtml2pdf
  },
  props: {
    downloadLabel: {type: String}
  },
  setup: () => {
    const store = useStore();
    const html2pdf = ref();
    const results = computed(() => store.state.results)
    const htmlToPdfOptions: object = {
      margin: .8,
      filename: `study-inspirator-results.pdf`,
      image: {
        type: 'jpeg',
        quality: 1
      },
      html2canvas: {
        scale: 1,
        useCORS: true
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait'
      }
    }

    function download() {
      html2pdf.value.generatePdf();
    }

    function sortedRatings(): string[] {
      let result = results;
      if (result) {
        return Object.keys(result).sort().reverse();
      }

      return [];
    }

    return {
      download,
      results,
      htmlToPdfOptions,
      resultViewModel: computed(() => store.getters.resultViewModel),
      highestRating: computed(() => store.getters.highestRating),
      sortedRatings
    }
  }
})
